/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for sortOrderNullPlacement. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="sortOrderNullPlacement"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="first"/&gt; &lt;enumeration value="last"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class SortOrderNullPlacement extends Enum{

	enumValue = null;

	static  FIRST = SortOrderNullPlacement.newLiteral("first");

	static  LAST = SortOrderNullPlacement.newLiteral("last");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < SortOrderNullPlacement.values().length); ++i) {
			if (SortOrderNullPlacement.values()[i].enumValue == v) {
				return SortOrderNullPlacement.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("SortOrderNullPlacement" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/SortOrderNullPlacement.js